import React, { useEffect, useState } from "react";
import { useThemesContext } from "../../../../context/ThemeProvider";
import { Button } from "components";
import { Trash } from "../../../../../../components/icons";
import { TableEdit } from "../../../../../dashboard/icons";

export const RadioButtonUncheckedIcon = () => <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="16" height="16" rx="8" fill="white" stroke="#DFE5E9" strokeWidth="2"/>
</svg>;
export const RadioButtonCheckedIcon = () => <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="12" height="12" rx="6" stroke="#6A3CE2" strokeWidth="6"/>
</svg>;
export const ExternalLink = () => <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.75 5.25H5C4.60218 5.25 4.22064 5.40804 3.93934 5.68934C3.65804 5.97064 3.5 6.35218 3.5 6.75V13.5C3.5 13.8978 3.65804 14.2794 3.93934 14.5607C4.22064 14.842 4.60218 15 5 15H11.75C12.1478 15 12.5294 14.842 12.8107 14.5607C13.092 14.2794 13.25 13.8978 13.25 13.5V9.75" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M8 10.5L15.5 3" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M11.75 3H15.5V6.75" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>


const SettingsSelectMenu = ({ id, label, initialValue, onChange }) => {

  const { menus } = useThemesContext();

  const [isOpen, setIsOpen] = useState(false);
  const [menu, setMenu] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(null);

  const hasMenu = !!menu;

  const handleOpenSelectMenu = () => {
    setIsOpen(true);
  };

  const handleCloseSelectMenu = () => {
    setSelectedMenu(null);
    setIsOpen(false);
  };

  const handleChange = menu => {
    setSelectedMenu(menu);
  };

  const handleSelect = () => {
    setMenu(selectedMenu);
    onChange(id, selectedMenu?.title);
    handleCloseSelectMenu();
  };

  const handleEditMenu = () => {
    setSelectedMenu(menu);
    handleOpenSelectMenu();
  };

  const handleDeleteMenu = () => {
    setMenu(null);
    onChange(id, '');
  };

  const renderSelectMenuBlock = showSelectButton => (
    <div>
      {menus && menus?.map(menu => (
          <div className="cursor-pointer mb-2 d-flex align-items-center justify-content-start w-100" key={menu.id} onClick={() => handleChange(menu)}>
            <div className="p-2 pl-0">
              {selectedMenu?.id === menu?.id ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}
            </div>
            <div className="paylixecommerce-label mb-0 ml-2">{menu?.title}</div>
          </div>
      ))}

      <div className="d-flex justify-content-between mt-4 mb-3">
        <Button variant="secondary" size="large" className={showSelectButton ? 'mr-2 w-50' : "w-100"} onClick={handleCloseSelectMenu}>
          Cancel
        </Button>

        {showSelectButton && <Button size="large" className="w-50" onClick={handleSelect}>Select</Button>}
      </div>

      <a href="https://dashboard.paylix.gg/customization/navigation" target="_blank">
        <Button variant="secondary" size="large" className="w-100">
          Create menu&nbsp;<ExternalLink />
        </Button>
      </a>
    </div>
  );

  useEffect(() => {
    initialValue
      ? setMenu(menus?.find(({ title }) => title === initialValue))
      : setMenu(null);
  }, [initialValue, menus]);

  return (
    <div className="mb-4">
      <div className="paylixecommerce-label">
        {label}
      </div>

      {hasMenu ? (
        <div className="select-menu-block">
          {isOpen ? (
            renderSelectMenuBlock(menu?.id !== selectedMenu?.id)
          ) : (
            <div className="d-flex align-items-center justify-content-between">
              <div className="visual-menu-block-header-title">{menu?.title}</div>

              <div className="d-flex">
                <div onClick={handleEditMenu} className="visual-menu-icon">
                  <TableEdit />
                </div>

                <div onClick={handleDeleteMenu} className="visual-menu-icon delete-icon">
                  <Trash />
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="select-menu-block empty">
          {isOpen ? (
            renderSelectMenuBlock(!!selectedMenu)
          ) : (
            <Button size="large" onClick={handleOpenSelectMenu} className="w-100">
              Select menu
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default SettingsSelectMenu;
